
import zhizhen from '@/assets/jfcj/zhuanpan-zhizhen.png'
import zhizhenGray from '@/assets/jfcj/zhuanpan-zhizhen-gray.png'
import openbg from '@/assets/jifenhuangou/lottery/popup-bg.png'
import config from '@/config'
import { getintegral, operateCreditlist } from '@/api/user.js'
import { award } from '@/api/lottery'
import XDialog from 'vux/src/components/x-dialog/index.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'
import XButton from 'vux/src/components/x-button/index.vue'

import {
addCreditParty,
relation,
view,
addPartyCount,
cutCreditPartyNum,
cutCreditParty
} from '@/api/jfhl.js'
import { getUserItem } from '@/api/lottery.js'
export default {
directives: {
TransferDom
},
components: {
XDialog,
XButton
},
data () {
return {
baseUrl: config.baseUrl,
lottimg: '', // 抽奖图
banner: '', // banner
bgColor: '', // 主题颜色
ruleInfo: '', // 规则
lotNum: 3, // 抽奖次数

checkstyle: false,
zhizhen: zhizhen,
times: '', // 答题次数
lotid: 0,
showOpen: false,
openbg: openbg,
prize: '',
start_rotating_degree: 0, // 初始旋转角度
rotate_angle: 0, // 将要旋转的角度
rotate_transition: 'transform 6s ease-in-out', // 初始化选中的过度属性控制
rotate_transition_pointer: 'transform 10s ease-in-out', // 初始化指针过度属性控制
click_flag: true, // 是否可以旋转抽奖
partyid: this.$route.params.partyid,
partyuserid: this.$route.params.partyuserid,
prizelist: [], // 奖品列表
angle: '', // 转动角度
tablist: [
{
title: '活动规则'
},
{
title: '我的奖品'
}
],
selected: 0,
startTime: '',
endTime: '',
integral: '',
owner_type: config.owner_type,
isclick: false
}
},
created () {
this.addcount() 
this.addIntegral() 
this.getview() 
this.getintegralTotal() 
},
computed: {
accountid () {
return this.$store.state.user.accountid
},
userid () {
return this.$store.state.user.userid
},
top () {
return -this.activeIndex * 30 + 'px'
}
},
methods: {

addcount () {
addPartyCount({
partyid: this.partyid,
accoutid: this.accountid,
credittype: 1
}).then(res => {})
},

addIntegral (credit) {
operateCreditlist({
accountid: this.accountid,
rulecode: 'party_rule',
credit: 1,
owner_type: this.owner_type,
relationtype: 2,
relationid: 1,
terminaltype: 2
}).then(res => {})
},

addJiFen (credit) {
addCreditParty({
accoutid: this.accountid,
credit: credit,
partyid: this.partyid,
type: 1
}).then(res => {})
},

getActiveNum () {
cutCreditPartyNum({
accoutid: this.accountid
}).then(res => {
if (this.lotNum - parseInt(res.obj.num) <= 0) {
this.isclick = true
this.zhizhen = zhizhenGray
this.$vux.alert.show({
content: '您的抽奖次数已经用完'
})
}
})
},

getview () {
view({
id: this.partyid
}).then(res => {
this.lottimg = res.obj.hdpicList[0].FILEPATH
this.banner = res.obj.toppicList[0].FILEPATH
this.bgColor = res.obj.explist[0].ATTRCODE || '#b71c23'
this.ruleInfo = res.obj.hddesc
this.lotid = res.obj.lotid
this.startTime = res.obj.signstartdate.replace(/-/g, '/')
this.endTime = res.obj.signenddate.replace(/-/g, '/')
this.isCurrentTime(this.startTime, this.endTime)
this.getWinning()
})
},

isCurrentTime (beginTime, endTime) {
var currentTime = new Date()
beginTime = new Date(beginTime)
endTime = new Date(endTime)
if (currentTime < beginTime) {
this.$vux.alert.show({
content: '抽奖活动还未开始'
})
this.isclick = true
this.zhizhen = zhizhenGray
return false
}
if (currentTime >= endTime) {
this.$vux.alert.show({
content: '抽奖活动已结束'
})
this.isclick = true
this.zhizhen = zhizhenGray
return false
}
this.isclick = false
this.getActiveNum()
},

cutCredit (credit, fn) {
cutCreditParty({
accoutid: this.accountid,
credit: credit,
partyid: this.partyid,
partytype: 'party'
}).then(() => {
if (fn) fn()
})
},

getintegralTotal () {
getintegral({
accountid: this.accountid,
owner_type: this.owner_type,
userid: this.userid
}).then(res => {
this.integral = res.returnValue.allnow
})
},

go () {
if (!this.isclick) {
if (!this.checkstyle) {
this.$vux.alert.show({
content: '请点击勾选下方栏位，确认相关规则后再参与活动'
})
return false
}
this.isaward()
this.isclick = true
}
},
ontab (index) {
this.selected = index
},

isaward () {
award({
lotid: this.lotid,
openid: this.userid,
lotteryNum: 5
}).then(data => {
if (data.success) {
if (data.obj.isaward === 2) {
this.zhizhen = zhizhenGray
this.$vux.alert.show({
content: '已抽过奖'
})
} else {
this.angle = data.obj.angle
this.prize = data.obj.item
this.cutCredit(10, () => {
if (data.obj.item !== '谢谢参与') {
this.addJiFen(data.obj.item.replace(/[^0-9]/gi, ''))
}
})
this.rotating(parseInt(this.angle))

relation({
partyuserid: this.partyuserid,
lotid: this.lotid,
userid: this.accountid,
openid: this.userid
}).then(data => {})
}
}
})
},

rotating (degree) {

var type = 0 
var during_time = 5 
var rand_circle = 5 
if (type === 0) {

var rotate_angle =
this.start_rotating_degree +
(360 - (this.start_rotating_degree % 360)) +
rand_circle * 360 +
degree 
this.start_rotating_degree = rotate_angle
this.rotate_angle = 'rotate(' + rotate_angle + 'deg)'

setTimeout(() => {
this.winning()
}, during_time * 1000)
}
},

getWinning () {
getUserItem({
openid: this.userid,
lotid: this.lotid
}).then(res => {
this.prizelist = res.obj.items
})
},

winning () {
setTimeout(() => {
this.showOpen = true
}, 2000)
},

close () {
this.showOpen = false
this.isclick = false
this.getWinning()
this.getintegralTotal()
this.getActiveNum()
}
}
}
